import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import CroppedImage from 'rebook/apps/utils/components/CroppedImage';
import MultilineEllipsisText from 'rebook/apps/base/components/MultilineEllipsisText';
import pluralize from 'rebook/apps/utils/text/pluralize';

import styles from './style.scss';


const SeriesItem = ({ series }) => {
  const serieLink = {
    pathname: series.absolute_url,
    state: {
      series,
    },
  };

  return (
    <div className={classNames(styles.item, 'swiper-slide')}>
      <div className={styles.container}>
        <Link to={serieLink}>
          <div className={styles.containerBackground}>
            <CroppedImage
              src={series.cover}
              alt={series.name}
              height="160"
              width="106"
              className={styles.image} />
          </div>
          <div className={styles.content}>
            <div className={styles.coverContainer}>
              <div className={styles.cover}>
                <CroppedImage
                  src={series.cover}
                  alt={series.name}
                  height="160"
                  width="106"
                  className={styles.image} />
              </div>
            </div>
            <div className={styles.information}>
              <div className={styles.title}>
                <MultilineEllipsisText maxLinesCount={3}>
                  {series.name}
                </MultilineEllipsisText>
              </div>
              <div className={styles.count}>
                {series.active_book_count} {pluralize(series.active_book_count, 'книга', 'книги', 'книг')}
              </div>
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default SeriesItem;
